import { render, staticRenderFns } from "./PackagingBlock.vue?vue&type=template&id=5cc747d2&scoped=true"
import script from "./PackagingBlock.vue?vue&type=script&lang=js"
export * from "./PackagingBlock.vue?vue&type=script&lang=js"
import style0 from "./PackagingBlock.vue?vue&type=style&index=0&id=5cc747d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc747d2",
  null
  
)

export default component.exports